import React from 'react';

import { Icon, InputAdornment } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { omit } from 'lodash';

import { OldTextField, OldTextFieldProps } from '../OldTextField';

const styles = () => ({
  closeIcon: {
    cursor: 'pointer',
  },
});

export interface OldTextFieldSearchProps extends Omit<OldTextFieldProps, 'onChange'> {
  classes: any;
  className?: string;
  onChange?: (v: string) => void;
}

const OldTextFieldSearch: React.FC<OldTextFieldSearchProps> = ({
  classes,
  value,
  size = 'default',
  onChange = () => undefined,
  ...other
}) => (
  <OldTextField
    size={size}
    value={value}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <Icon fontSize={size}>search</Icon>
        </InputAdornment>
      ),
      endAdornment: (
        <InputAdornment position="end">
          {!!value && (
            <Icon className={classes.closeIcon} fontSize={size} onClick={() => onChange('')}>
              close
            </Icon>
          )}
        </InputAdornment>
      ),
      ...other.InputProps,
    }}
    onChange={(event: any) => onChange(event.target.value)}
    {...omit(other, 'InputProps')}
  />
);

export default withStyles(styles)(OldTextFieldSearch);
